// reducers/studentReducer.js
export const studentReducer = (
  state = {
    students: [],
    myChild: null,
    myChildren: [],
    selectedChildId: null,
    siblings: [],
  },
  action,
) => {
  switch (action.type) {
    // ── Loading ──
    case "ALL_STUDENTS_REQUEST":
    case "STUDENT_DETAIL_REQUEST":
    case "CREATE_STUDENT_REQUEST":
    case "MY_CHILD_REQUEST":
    case "MY_CHILDREN_REQUEST":
      return { ...state, loading: true, error: null };

    // ── Success ──
    case "ALL_STUDENTS_SUCCESS":
      return { ...state, loading: false, students: action.payload };

    case "STUDENT_DETAIL_SUCCESS":
      return { ...state, loading: false, student: action.payload };

    case "STUDENT_SIBLINGS_SUCCESS":
      return { ...state, siblings: action.payload };

    case "CREATE_STUDENT_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        student: action.payload,
      };

    // ── MY CHILD (parent portal, single — kept for backward compat) ──
    case "MY_CHILD_SUCCESS":
      return { ...state, loading: false, myChild: action.payload };

    // ── MY CHILDREN (parent portal, multiple) ──
    case "MY_CHILDREN_SUCCESS":
      return { ...state, loading: false, myChildren: action.payload };

    // Which child the parent portal is currently showing data for
    case "SET_SELECTED_CHILD":
      return { ...state, selectedChildId: action.payload };

    // ── Fail ──
    case "ALL_STUDENTS_FAIL":
    case "STUDENT_DETAIL_FAIL":
    case "CREATE_STUDENT_FAIL":
    case "MY_CHILD_FAIL":
    case "MY_CHILDREN_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
